/**
 * data-layer-performace.client.ts
 *
 * Reports Core Web Vitals to the legacy nhstDataLayer (PERFORMANCE_REPORT
 * envelope, consumed by Adobe Satellite).
 *
 * The cpp producer contract v2 has no web-vital event — `attributes` is narrowed
 * to action | edition_id | name and there is no system_action metric shape — so
 * web vitals are NOT emitted to @nhst/tracking-lib. They remain legacy-only.
 *
 * Notes:
 *   - FID was deprecated by web-vitals v4 (and Google itself replaced it
 *     with INP in March 2024). We emit onINP instead. The web-vitals package
 *     in this repo (v3.5) supports both, so the change is safe.
 *   - Filename keeps the misspelled "performace" for backwards-compatible
 *     plugin ordering with Nuxt's file-based autoloading. Rename in the
 *     cut-over PR alongside the other deletions.
 */
import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';
import { useDataLayerEvent } from '~/composables/useDataLayerEvent';

export default defineNuxtPlugin(() => {
  function report (metric: Metric) {
    // Legacy: PERFORMANCE_REPORT into window.nhstDataLayer → Adobe Satellite
    useDataLayerEvent().performanceEvent(metric.name, { performanceInfo: metric });
  }

  onCLS(report);
  onINP(report);
  onLCP(report);
});
